import styled, { css } from "styled-components";

interface PopupAlertProps {
  $subText?: boolean;
}

export const PopupAlertBox = styled.div`
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100svh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const PopupAlert = styled.div`
  display: flex;
  width: 80vw;
  max-height: 80vh;
  background: white;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  flex-direction: column;
`;

export const PopupTitle = styled.div<PopupAlertProps>`
  ${(props) =>
    props.$subText
      ? css`
          padding: 10px 0px;
        `
      : css`
          padding: 30px 30px 0;
        `}
  color: black;
  font-size: 1.6rem;
  font-weight: 600;
`;

export const PopupContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PopupContent = styled.div<PopupAlertProps>`
  ${(props) =>
    props.$subText
      ? css`
          padding: 20px 0px 0px;
          font-weight: 700;
        `
      : css`
          padding: 26px 30px 20px;
        `}
  color: rgba(0, 0, 0, 0.8);
  font-size: 1.4rem;
  line-height: 160%;
  text-align: center;
  white-space: pre-line;
`;

export const PopupSubContent = styled.div`
  padding: 0px 50px 0px;
  color: #71717a;
  font-size: 1.4rem;
  line-height: 160%;
  text-align: center;
  word-break: keep-all;
  white-space: pre-line;
`;

export const PopupButtons = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  justify-content: center;
  gap: 4px;

  button {
    width: 100%;
    height: 48px;
    padding: 0 14px;
    color: #2f54eb;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 48px;
    border: none;
    border-radius: 4px;
    background: white;

    &:active {
      background: #2f54eb0d;
    }
  }
`;
